import * as React from 'react';
import { useLocation } from 'react-router';

type ChatState = 'closed' | 'opening' | 'open' | 'closing';

interface BhanzuBuddyStateProps {
  isControlledComp: boolean;
  controlledIsOpen?: boolean;
  defaultMode: 'explain' | 'guide';
  initialSource: string;
}

export const useBhanzuBuddyState = ({
  isControlledComp,
  controlledIsOpen,
  defaultMode,
  initialSource,
}: BhanzuBuddyStateProps) => {
  const initialChatState: ChatState =
    isControlledComp && controlledIsOpen ? 'open' : 'closed';

  const [internalIsOpen, setInternalIsOpen] = React.useState(false);
  const [chatState, setChatState] = React.useState<ChatState>(initialChatState);
  const [currentMode, setCurrentMode] = React.useState<'explain' | 'guide'>(
    defaultMode
  );
  const [currentSource, setCurrentSource] = React.useState(initialSource);
  const [message, setMessage] = React.useState('');
  const quickChallengeContextRef = React.useRef<{
    questionByBB: string;
  } | null>(null);
  const prevMessageRef = React.useRef('');
  const inputRef = React.useRef<HTMLInputElement>(null);
  const chatContainerRef = React.useRef<HTMLDivElement>(null);
  const chatInterfaceRef = React.useRef<HTMLDivElement>(null);
  const hasScrolledOnOpen = React.useRef(false);

  const location = useLocation();
  const [hasUserInteracted, setHasUserInteracted] = React.useState(false);
  const [orientation] = React.useState(false);
  const [showQuickChallenge, setShowQuickChallenge] = React.useState({
    open: false,
    question: '',
    category: '',
    color: 'underwater-fern-green',
  });
  const [quickChallengeSnoozeUntil, setQuickChallengeSnoozeUntil] =
    React.useState(0);

  const isOpen = isControlledComp
    ? (controlledIsOpen ?? false)
    : internalIsOpen;

  return {
    chatState,
    setChatState,
    currentMode,
    setCurrentMode,
    currentSource,
    setCurrentSource,
    message,
    setMessage,
    quickChallengeContextRef,
    prevMessageRef,
    inputRef,
    chatContainerRef,
    chatInterfaceRef,
    hasScrolledOnOpen,
    location,
    hasUserInteracted,
    setHasUserInteracted,
    orientation,
    showQuickChallenge,
    setShowQuickChallenge,
    quickChallengeSnoozeUntil,
    setQuickChallengeSnoozeUntil,
    isOpen,
    internalIsOpen,
    setInternalIsOpen,
  };
};
